// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// types
import { DefaultRootStateProps } from 'types';
import { ProcessListRequestParams, ProcessSearchRequestParams } from 'types/process';

// ----------------------------------------------------------------------

const initialState: DefaultRootStateProps['process'] = {
    error: null,
    processData: [],
    nextPageToken: '',
    lastPageToken: '',
    loading: false,
    reprocessLoading: []
};

const slice = createSlice({
    name: 'process',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },
        getProcessList(state, action) {
            state.lastPageToken = (state.nextPageToken !== state.lastPageToken && state.nextPageToken) || '';
            state.processData = Array.isArray(action.payload) ? action.payload : [];
        },
        setLoading(state, action) {
            state.loading = action.payload;
        },
        nextPageToken(state, action) {
            state.nextPageToken = action.payload;
        },
        addReprocessLoadingState(state, action) {
            state.reprocessLoading = [...state.reprocessLoading, action.payload];
        },
        removeReprocessLoadingState(state, action) {
            state.reprocessLoading = state.reprocessLoading.filter((i) => i !== action.payload);
        }
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

const ENV = process.env;

export function getProcessList({ initDateTime, endDateTime, limit, storeId, status, process, nextPageToken }: ProcessListRequestParams) {
    return async () => {
        try {
            dispatch(slice.actions.setLoading(true));

            const response = await axios('/process', {
                baseURL: ENV.REACT_APP_SERVICES_URL,
                method: 'GET',
                params: {
                    initDateTime,
                    endDateTime,
                    ...(limit && { limit }),
                    ...(storeId && { storeId }),
                    ...(status && { status }),
                    ...(process && { process })
                },
                headers: {
                    ...(nextPageToken && { 'x-next-page-token': nextPageToken })
                }
            });

            if (response.status !== 200) throw new Error(response.data);

            const iNextPageToken = response.headers['x-next-page-token'];

            dispatch(slice.actions.getProcessList(response?.data));
            iNextPageToken && response?.data.length === limit && dispatch(slice.actions.nextPageToken(iNextPageToken));
            dispatch(slice.actions.setLoading(false));
        } catch (error) {
            console.error(error);

            dispatch(slice.actions.hasError(error));
        }
    };
}

export function searchProcess({ search, limit, nextPageToken }: ProcessSearchRequestParams) {
    return async () => {
        try {
            console.log(search);

            const response = await axios('/process/search', {
                baseURL: ENV.REACT_APP_SERVICES_URL,
                method: 'GET',
                params: {
                    documentId: search,
                    process: '',
                    ...(limit && { limit })
                },
                headers: {
                    ...(nextPageToken && { 'x-next-page-token': nextPageToken })
                }
            });

            if (response.status !== 200) throw new Error(response.data);

            const iNextPageToken = response.headers['x-next-page-token'];

            dispatch(slice.actions.getProcessList(response?.data));
            iNextPageToken && response?.data.length === limit && dispatch(slice.actions.nextPageToken(iNextPageToken));
        } catch (error) {
            console.error(error);

            dispatch(slice.actions.hasError(error));
        }
    };
}
export function reprocessLoadingState(id: string, removeAction: boolean) {
    return async () => {
        try {
            removeAction ? dispatch(slice.actions.removeReprocessLoadingState(id)) : dispatch(slice.actions.addReprocessLoadingState(id));
        } catch (error) {
            console.error(error);

            dispatch(slice.actions.hasError(error));
        }
    };
}
